export default "__VITE_ASSET__25dcfa1d__"